export default __webpack_public_path__ + "static/media/logo-HD-fond-transparent-titre.62405a84.png";